import React from "react";
import { Box } from "@mui/material";
import CommonModal from "./CommonModal";

interface Warningprops {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  errorMessage?: string;
  saveText?: string;
  warningInfo?: any;
}

const InfoModal: React.FC<Warningprops> = ({
  open,
  onClose,
  onConfirm,
  errorMessage,
  saveText = 'Save',
  warningInfo = 'You are about to move <<Device>>to the Warehouse'
}) => {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      onSave={() => {
        console.log("✅ onSave triggered in CommonModal (from InfoModal)"); // 🔥 STEP 2
        onConfirm();
      }}
      title=""
      saveText={saveText}
      cancelText="Cancel"
      maxWidth="480px"
      titleWithWarningIcon={true}
      showOnlineOffline={false}
      showSyncStatus={false}
    >


      <Box sx={{ p: 3, textAlign: "center" }}>

        {warningInfo}

        {errorMessage?.trim() && (
          <Box id='delete-error-message'>
            {errorMessage}
          </Box>
        )}
      </Box>
    </CommonModal>
  );
};

export default InfoModal;